// @flow

import * as React from 'react';

const ViewSiteSensors = () => <div>ViewSiteSensors</div>;

export default ViewSiteSensors;
